import '@vimeo/bokeh-theme/public/fonts/bokeh.css';

export default function BokehFont() {
  return null;
}
